
import { Report, ReportVersion, User } from ".";
import { LocationType } from "./Enums";

export class OrderData {
  reportId: string;

  optionalOrderBV: boolean = true;
  optionalOrderEA: boolean = false;

  reportType: string = 'CONCLUSION';
  isPurpose: boolean = true;
  isPurposeDesc: string;
  rushRequired: boolean = false;
  rushSpeed: number;
  companyName: string;
  tradeName: string;
  multi_locations: boolean;
  moreLoc: string;

  personSubmit: Contact = new Contact();
  q_company: Contact = new Contact();
  lender: Contact = new Contact();
  authContact: Contact = new Contact();

  q_add_company: Contact;
  addr_addr: string;
  addr_city: string;
  addr_state: string;
  addr_zip: string;
  phone: string;

  auth_contact: boolean;
  authContactNa: boolean;
  valuation_purpose: string;
  valuation_other: string;
  person_other: string;
  lender_other: string;
  company_other: string;
  addComments: string;
  eaReportType: string;
  eaMultiLocation: boolean;
  eaEqLocations: string;

  includeReport: boolean = false;

  static createFormData(report: Report, user: User, includeReport: boolean): OrderData {
    let data = new OrderData();

    data.reportId = report.ID;
    data.includeReport = includeReport;

    data.companyName = report.LATEST.COMPANY.NAME;
    data.tradeName = report.LATEST.COMPANY.DBA;
    if (report.LATEST.LOCATION_LIST && report.LATEST.LOCATION_LIST.length > 1) {
      data.multi_locations = true;
      let descValue = '';

      for (let loc of report.LATEST.LOCATION_LIST)
        descValue = descValue + `${loc.NAME} (${loc.LOCATION_TYPE})${loc.LOCATION_TYPE === LocationType.OTHER ? ', ' + loc.OTHER_TYPE : ''}: ${loc.ADDRESS}${loc.ADDRESS ? ', ' + loc.ADDRESS : ''}, ${loc.CITY}, ${loc.STATE} ${loc?.ZIP?.ZIP}\n`;
      data.moreLoc = descValue;
    } else data.multi_locations = false;

    data.personSubmit = new Contact();
    data.personSubmit.name = `${user.NAME_FIRST} ${user.LAST_ACTIVITY}`;
    data.personSubmit.company = user.COMPANY;
    data.personSubmit.email = user.EMAIL;
    data.personSubmit.phone = user.TELEPHONE;
    data.personSubmit.contact = 'LENDER';

    return data;
  }
}

export class Contact {
  name: string;
  contact: string;
  email: string = '';
  phone: string = '';
  company: string;
  phoneType: string;
}


export class Order {
  BV_SERVICE: boolean;

  BV_TYPE: ValuationType;
  EA_TYPE: AppraisalType;

  COMPANY_NAME: Array<string>;
  COMPANY_DBA: string;

  EA_LOCATIONS: string;
  RUSH: boolean;
  RUSH_SPEED: number;
  PURPOSE_FINANCING: boolean;
  PURPOSE_DESC: string;
  MULTI_LOCATION: boolean;
  MULTI_LOCATION_DESC: string;

  PERSON_SUBMIT: OrderContact;
  PERSON_COMPANY: OrderContact;
  PERSON_LENDER: OrderContact;
  PERSON_SELLER: OrderContact;

  SELLER_CAN_CONTACT: boolean;
  SELLER_NOT_AVAILABLE: boolean;
  SELLER_PERMISSION: boolean;

  COMMENTS: string;
  PRIVACY_POLICY: boolean;

  EASY_USE: boolean;
  SUGGESTIONS: string;

  VALZY_REPORT_ID: string;
  INCLUDE_REPORT: boolean;

  static createFormData(report: ReportVersion, user: User, includeReport: boolean, ignoreLocations: boolean = false): Order {
    let data = new Order();

    data.BV_SERVICE = true;
    data.BV_TYPE = ValuationType.CONCLUSION;

    data.VALZY_REPORT_ID = report.ID;
    data.INCLUDE_REPORT = includeReport;

    data.PURPOSE_FINANCING = true;
    data.RUSH = false;

    if (report?.COMPANY?.NAME)
      data.COMPANY_NAME = [report.COMPANY.NAME];

    if (report?.COMPANY?.DBA)
      data.COMPANY_DBA = report.COMPANY.DBA;

    if (!ignoreLocations) {
      if (report.LOCATION_LIST && report.LOCATION_LIST.length > 1) {
        data.MULTI_LOCATION = true;
        let descValue = '';

        for (let loc of report.LOCATION_LIST)
          descValue = descValue + `${loc.NAME} (${loc.LOCATION_TYPE})${loc.LOCATION_TYPE === LocationType.OTHER ? ', ' + loc.OTHER_TYPE : ''}: ${loc.ADDRESS}${loc.ADDRESS ? ', ' + loc.ADDRESS : ''}, ${loc.CITY}, ${loc.STATE} ${loc?.ZIP?.ZIP}\n`;
        data.MULTI_LOCATION_DESC = descValue;
      } else data.MULTI_LOCATION = false;
    }

    data.PERSON_SUBMIT = new OrderContact();
    data.PERSON_SUBMIT.FIRST_NAME = user.NAME_FIRST;
    data.PERSON_SUBMIT.LAST_NAME = user.NAME_LAST;
    data.PERSON_SUBMIT.EMAIL = user.EMAIL;
    data.PERSON_SUBMIT.PHONE = user.TELEPHONE;
    data.PERSON_SUBMIT.CONTACT = 'LENDER';

    return data;
  }
}

export class OrderContact {
  FIRST_NAME: string;
  LAST_NAME: string;
  CONTACT: string;
  EMAIL: string;
  PHONE: string;
  PHONE_TYPE: PhoneType;
  OTHER: string;

  constructor(value: Object = {}) {
    this.FIRST_NAME = '';
    this.LAST_NAME = '';
    this.CONTACT = '';
    this.EMAIL = '';
    this.PHONE = '';
    this.OTHER = '';

    Object.assign(this, value);
  }

  /**
   * @description: Reset
   * */
  reset(): void {
    this.CONTACT = '';
    this.EMAIL = '';
    this.FIRST_NAME = '';
    this.LAST_NAME = '';
    this.OTHER = '';
    this.PHONE = '';
  }
}

export enum ValuationType {
  CONCLUSION = 'CONCLUSION',
  CALCULATION = 'CALCULATION',
  IV = 'IV',
  OTHER = ''
}

export enum AppraisalType {
  DESKTOP = 'DESKTOP',
  SUMMARY = 'SUMMARY'
}

export enum PhoneType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS'
}


export class Release {
  BANK_NAME: string;
  COMPANY_NAME: string;
  IAGREE: boolean;

  BORROWER: ReleaseContact;
  LENDER: ReleaseContact;
}

export class ReleaseContact {
  EMAIL: string;
  NAME_FIRST: string;
  NAME_LAST: string;
}
